import {didIntercomBoot} from './did-intercom-boot';

export const isIntercomAvailable = (): boolean => {
    return Boolean(window.Intercom) && (window.Intercom?.booted ?? false) && didIntercomBoot();
};
